const formControlLabelFormControlAbel = {
  label: 'BAJO DEMANDA (SIN TIEMPO DEFINIDO)'
};

export default formControlLabelFormControlAbel;
